export default __webpack_public_path__ + "static/media/green1.fae7b1af.svg";